import React from "react";
import { ActionIcon } from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

// A lightweight breadcrumb bar for Browse's in-modal navigation. The app's
// existing Breadcrumbs.js is built around react-router <Link>s to real
// pages; Browse never changes the URL (it's state-driven inside a modal),
// so this renders `segments` ({ label, onClick }) directly instead — the
// last segment is the current location and isn't clickable. An optional
// `onBack` renders a dedicated back button that steps to the previous
// directory (or out to the matters list), independent of clicking a
// specific crumb.
const BrowseBreadcrumbs = ({ segments, onBack }) => (
	<div
		style={{
			display: "flex",
			flexWrap: "wrap",
			alignItems: "center",
			gap: 4,
			fontSize: 13,
			marginBottom: 8,
		}}
	>
		{onBack ? (
			<ActionIcon
				variant="subtle"
				size="sm"
				title="Back"
				onClick={onBack}
				style={{ flexShrink: 0, marginRight: 4 }}
			>
				<IconChevronLeft size={16} />
			</ActionIcon>
		) : null}
		{segments.map((segment, i) => {
			const isLast = i === segments.length - 1;
			return (
				<React.Fragment key={i}>
					{i > 0 ? (
						<IconChevronRight
							size={13}
							color="#999"
							style={{ flexShrink: 0 }}
						/>
					) : null}
					{isLast || !segment.onClick ? (
						<span
							style={{
								color: isLast ? "inherit" : "#888",
								fontFamily: isLast
									? "MainFont-Bold"
									: undefined,
								overflow: "hidden",
								textOverflow: "ellipsis",
								whiteSpace: "nowrap",
								maxWidth: 220,
							}}
						>
							{segment.label}
						</span>
					) : (
						<button
							type="button"
							onClick={segment.onClick}
							style={{
								background: "none",
								border: "none",
								padding: 0,
								cursor: "pointer",
								color: "var(--lxw-hyperlink)",
								textDecoration: "underline",
								overflow: "hidden",
								textOverflow: "ellipsis",
								whiteSpace: "nowrap",
								maxWidth: 220,
							}}
						>
							{segment.label}
						</button>
					)}
				</React.Fragment>
			);
		})}
	</div>
);

export default BrowseBreadcrumbs;
